export default [
	{
		path: '/shares',
		name: 'shares',
		props: true,
		// component: () => import( '@/views/shares/index.vue' ),
		component: { render: h => h( 'router-view' ) },
		meta: {
			title: '会议分享'
		},
		children: [
			{
				path: '1',
				name: 'template_blue',
				meta: { title: '模板蓝' },
				component: { render: h => h( 'router-view' ) },
				children: [
					{
						path: '',
						name: 'index',
						// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_blue/index.vue' )
					},
					{
						path: 'detail',
						name: 'Detail',
						// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_blue/detail.vue' )
					},
					{
						path: 'list',
						name: 'List',
						// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_blue/list.vue' )
					},
					{
						path: 'videolist',
						name: 'VideoList',
						// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_blue/videolist.vue' )
					},
				]
			},
			{
				path: '2',
				name: 'template_red',
				meta: { title: '模板红' },
				component: { render: h => h( 'router-view' ) },
				children: [
					{
						path: '',
						name: 'index',
						// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_red/index.vue' ),
					},
					{
						path: 'detail',
						name: 'Detail',
						// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_red/detail.vue' )
					},
					{
						path: 'list',
						name: 'List',
						// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_red/list.vue' )
					},
					{
						path: 'videolist',
						name: 'VideoList',
						// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_red/videolist.vue' )
					},
				]
			},
			{
				path: '3',
				name: 'template_gray',
				meta: { title: '模板灰' },
				component: { render: h => h( 'router-view' ) },
				children: [
					{
						path: '',
						name: 'index',
						// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_gray/index.vue' ),
					},
					{
						path: 'detail',
						name: 'Detail',
							// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_gray/detail.vue' )
					},
					{
						path: 'list',
						name: 'List',
								// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_gray/list.vue' )
					},
					{
						path: 'videolist',
						name: 'VideoList',
								// meta: { title: 'List' },
						component: () => import( '@/views/shares/template_gray/videolist.vue' )
					},
				]
			},
		]
	},
]
